import axios from 'axios';
import moment from 'moment';
import { getI18n } from 'react-i18next';
import { showErrorNotification } from './notifications';
import Constants from '../utils/Constants';
import {
    date,
} from '../utils';
import {
    getCachedFavicon,
    getCachedLogo,
    setCachedFavicon,
    setCachedLogo,
} from '../utils/browserStorage';

export const onLoadPublicConfigResponse = (dispatch) => (response) => {
    dispatch(publicConfigLoaded(response.data));
    const currentMoment = moment(date()).utc();
    const serverMoment = moment(response.headers.date).utc();
    const offsetInMs = serverMoment.diff(currentMoment);
    dispatch(serverTimeOffset(offsetInMs));
};

export const SERVER_TIME_OFFSET = 'SERVER_TIME_OFFSET';
export const serverTimeOffset = (offsetInMs) => ({
    type: SERVER_TIME_OFFSET,
    payload: offsetInMs,
});

export const onLoadPublicConfigError = (dispatch) => (error) => {
    const i18n = getI18n();
    const { response } = error;
    if (response) {
        dispatch(showErrorNotification(i18n.t('load-public-config.load-failed', { message: response.statusText })));
    } else {
        dispatch(showErrorNotification(i18n.t('load-public-config.load-failed', { message: error.message })));
    }
};

export const PUBLIC_CONFIG_LOADED = 'PUBLIC_CONFIG_LOADED';
export const publicConfigLoaded = (publicConfig) => {
    setCachedFavicon(publicConfig.favicon);
    setCachedLogo(publicConfig.logo);
    return {
        type: PUBLIC_CONFIG_LOADED,
        payload: publicConfig,
    };
};

export const LOAD_FAVICON = 'LOAD_FAVICON';
export const loadFavicon = (favicon) => ({
    type: LOAD_FAVICON,
    payload: favicon,
});

export const LOAD_LOGO = 'LOAD_LOGO';
export const loadLogo = (logo) => ({
    type: LOAD_LOGO,
    payload: logo,
});

export const loadPublicConfig = () => (dispatch) => {
    const cachedFavicon = getCachedFavicon();
    if (cachedFavicon) {
        dispatch(loadFavicon(cachedFavicon));
    }
    const cachedLogo = getCachedLogo();
    if (cachedLogo) {
        dispatch(loadLogo(cachedLogo));
    }
    axios.get(Constants.CONFIG_PATH + Constants.PUBLIC_CONFIG_PATH)
        .then(onLoadPublicConfigResponse(dispatch))
        .catch(onLoadPublicConfigError(dispatch));
};

export const PRIVATE_CONFIG_LOADED = 'PRIVATE_CONFIG_LOADED';
export const privateConfigLoaded = (privateConfig) => ({
    type: PRIVATE_CONFIG_LOADED,
    payload: privateConfig,
});

export const loadPrivateConfig = (accessToken) => (dispatch) => {
    axios.get(
        Constants.CONFIG_PATH + Constants.PRIVATE_CONFIG_PATH, {
            headers: {
                Authorization: `${Constants.BEARER_PREFIX} ${accessToken}`,
            },
        })
        .then(onLoadPrivateConfigResponse(dispatch))
        .catch(onLoadPrivateConfigError(dispatch));
};

export const onLoadPrivateConfigResponse = (dispatch) => (response) => dispatch(privateConfigLoaded(response.data));

export const onLoadPrivateConfigError = (dispatch) => (error) => {
    const i18n = getI18n();
    const { response } = error;
    if (response) {
        dispatch(showErrorNotification(i18n.t('load-private-config.load-failed', { message: response.statusText })));
    } else {
        dispatch(showErrorNotification(i18n.t('load-private-config.load-failed', { message: error.message })));
    }
};

export const WEB_SOCKET_ERROR_SENT_TIME = 'WEB_SOCKET_ERROR_SENT_TIME';
export const webSocketErrorSentTime = (timestamp) => ({
    type: WEB_SOCKET_ERROR_SENT_TIME,
    payload: timestamp,
});

export const sendWebSocketErrorNotification = (timestamp) => (dispatch) => {
    const i18n = getI18n();
    dispatch(showErrorNotification(i18n.t('misc.websocket-error')));
    dispatch(webSocketErrorSentTime(timestamp));
};

export const REMOVE_WEB_SOCKET_ERROR_SENT_TIME = 'REMOVE_WEB_SOCKET_ERROR_SENT_TIME';
export const removeWebSocketErrorSentTime = () => ({
    type: REMOVE_WEB_SOCKET_ERROR_SENT_TIME,
});
